import { defineComponent as _defineComponent } from 'vue'
import { globalParam } from '@/helpers/globals';

/** Proof-of-Concept of a Composition API component using a setup script only */

/** props definition */

export default /*#__PURE__*/_defineComponent({
  __name: 'NewsletterInfoCard',
  props: {
    height: {
        type: [String, Number],
        default: null,
    },
},
  setup(__props) {



return { __sfc: true,globalParam }
}

})